/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './queryStatuses.defs.js'
export * as $defs from './queryStatuses.defs.js'
